/** Shared pricing translation shape — imported by all locale files. */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const pricingTranslationsDe = {
  eyebrow: 'Pakete & Preise',
  perMonth: 'pro Monat',
  perYear: 'pro Jahr',
  copy: {
    pageTitle: 'Pläne & Preise',
    pageSubtitle:
      'Ein Ort zum Vergleichen der Pläne. Hobby ist für alle kostenlos. Pro ist ein persönliches Abo. Business ist eine einmalige WC-2026-Org-Gebühr (kein Pro). Enterprise wird mit unserem Team verhandelt.',
    comingSoonBadge: 'Demnächst',
    comingSoonInProduction: 'Demnächst in Produktion',
    mostPopularBadge: 'Am beliebtesten',
    currentPlanBadge: 'Dein Plan',
    createOrgCta: 'Organisation erstellen',
    footnote:
      'Pro wird über dein persönliches Konto abgerechnet (keine Org). Business ist eine einmalige WC-2026-Organisationsgebühr — erstelle eine Org, wähle deinen Sitz-Tarif und zahle einmal für Org-Zugang während des Turniers. Enterprise ist für Organisationen mit individuellen Preisen, Limits oder Verträgen — kontaktiere uns.',
    orgPlanDisclosure: WC2026_ORG_BILLING_DISCLOSURE,
    orgPlanDisclosureShort: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    footnoteCancelPolicy:
      'Wenn du Pro im Abrechnungsportal kündigst, hält Stripe deinen Plan bis zum Ende des bezahlten Zeitraums aktiv — du kannst bis dahin wieder aktivieren. Die App synchronisiert sich mit Stripe, wenn du hierher zurückkehrst.',
    signInToSubscribe: 'Anmelden zum Abonnieren',
    logIn: 'Anmelden',
    goBack: 'Zurück',
    manageSubscription: 'Abo verwalten',
    proAccessEndsOn: 'Pro-Zugang endet am',
    billingIntervalMonth: 'Monatlich',
    billingIntervalYear: 'Jährlich',
    switchToMonthly: 'Auf monatlich wechseln',
    upgradeToYearlyDialogMsg:
      'Jährliche Abrechnung ist eine 12-monatige Verpflichtung. Nach dem Wechsel kannst du bis zum Ende des Jahreszeitraums nicht wieder auf monatliche Abrechnung zurück — keine anteiligen Erstattungen.',
    upgradeToYearlyDialogConfirm: 'Auf jährlich wechseln',
    upgradeToYearlyDialogCancel: 'Monatlich behalten',
    switchToMonthlyDialogTitle: 'Auf monatliches Pro wechseln',
    switchToMonthlyDialogMsg:
      'Du wirst zu Stripe weitergeleitet, um auf monatliche Abrechnung zu wechseln. Dein jährlicher Pro-Zugang läuft bis zum Ende des aktuellen Zeitraums — monatliche Abrechnung beginnt danach. Keine Erstattung für ungenutzte Zeit.',
    switchToMonthlyConfirm: 'Zu Stripe',
    switchToMonthlyCancel: 'Jährlich behalten',
    upgradeToYearlyProTitle: 'Upgrade auf jährliches Pro',
    upgradeToYearlyProConfirm: 'Upgrade',
    enterpriseSubscribe: 'Abonnieren',
    enterpriseCheckoutAdminOnly: 'Bitte einen Org-Admin zum Abonnieren',
    upgradeSeatBucket: 'Upgrade',
    managePlan: 'Plan & Abrechnung',
    businessSubscribe: 'Abonnieren',
    upgradeMonthlyToYearlyDialog: {
      line1: 'Du wechselst von Monatliches Pro ({monthly}/month) zu Jährliches Pro ({yearly}/year).',
      line2:
        'Deine hinterlegte Zahlungsmethode wird mit der anteiligen Differenz für den laufenden Abrechnungszeitraum belastet.',
      line3:
        'Nach dem Wechsel auf jährlich kannst du bis zum Ende des Jahreszeitraums nicht wieder auf monatliche Abrechnung zurück.',
      line4: 'Fortfahren?',
    },
  },
  plans: {
    hobby: {
      name: 'Hobby',
      priceLabel: 'Kostenlos',
      tagline: 'Für Freunde und kleine Gruppen zum Einstieg.',
      ctaLabel: 'Loslegen',
      features: [
        'Kern-Challenges und Tipps',
        'Standard-Punktesystem (ohne Doubles)',
        'Standard-Spielzeilen pro Challenge',
        'Standard-Support',
        'Gelegentliche Werbung',
        'Ideal, um Zporti mit wenigen Leuten auszuprobieren',
      ],
    },
    proMonthly: {
      name: 'Pro · Monatlich',
      tagline: 'Für Einzelspieler und Freundesgruppen, die mehr Features wollen.',
      ctaLabel: 'Monatlich abonnieren',
      features: [
        'Alles aus Hobby',
        'Doubles aktiviert',
        'Mehr Spielzeilen pro Challenge',
        'Werbefreies Erlebnis',
        'Höhere Limits für Mitglieder und Aktivität',
        'Prioritäts-Support',
        'Stärkere Branding-Optionen',
      ],
    },
    proYearly: {
      name: 'Pro · Jährlich',
      tagline: 'Gleiche Pro-Features, einmal jährlich abgerechnet — ideal, wenn eure Gruppe langfristig dabei ist.',
      ctaLabel: 'Jährlich abonnieren',
      features: [
        'Alles aus Hobby',
        'Doubles aktiviert',
        'Mehr Spielzeilen pro Challenge',
        'Werbefreies Erlebnis',
        'Höhere Limits für Mitglieder und Aktivität',
        'Prioritäts-Support',
        'Stärkere Branding-Optionen',
      ],
    },
    business: {
      name: 'Business',
      priceLabel: 'From $450',
      tagline: 'Einmalige WC-2026-Org-Gebühr. Wähle deinen Sitz-Tarif und zahle einmal für Turnierzugang.',
      ctaLabel: 'Loslegen',
      features: [
        'Organisations-Branding (Farben & Logos)',
        'Mitgliedssitze — Pauschal-Tarife bis 2.000',
        'WC-2026-Turnier-Org-Zugang (gebrandete Org + verknüpftes Team)',
        'Prioritäts-Support',
        'Ohne persönliches Pro, Coins, Boosts oder In-App-Store-Käufe',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      priceLabel: 'Individuell',
      tagline: 'Verhandelte Org-Preise und Rollout für WC 2026 — im Auftrag oder Vertrag festgelegt.',
      ctaLabel: 'Kontaktiere uns',
      features: [
        'Organisations-Branding und Rollout (nach Vereinbarung)',
        'Mitgliederlimits mit dem Vertrieb abgestimmt',
        'WC-2026- und org-weite Features (nach Vereinbarung)',
        'Dedizierter Support & individuelles Onboarding',
        'Individuelle Integrationen, Rechnungsstellung & Verträge',
        'Ohne persönliches Pro, Coins, Boosts oder In-App-Store-Käufe',
      ],
    },
  },
  seatBuckets: {
    upTo100: 'Bis zu 100 Mitarbeiter',
    upTo250: 'Bis zu 250 Mitarbeiter',
    upTo500: 'Bis zu 500 Mitarbeiter',
    upTo1000: 'Bis zu 1.000 Mitarbeiter',
    upTo2000: 'Bis zu 2.000 Mitarbeiter',
  },
} as const

export const featuresSectionDe = {
  eyebrow: 'Was du bekommst',
  livePreview: 'Live-Vorschau',
  avatars: {
    title: 'Individuelle Avatare für jeden Spieler',
    description:
      'Gib jeder Person eine wiedererkennbare Identität, damit Tabellen, Rivalitäten und Sticheleien vom ersten Tag an persönlich wirken.',
    accessibilityLabel: 'Vorschau der individuellen Avatare',
  },
} as const

export const footerExtendedDe = {
  product: 'Produkt',
  compete: 'Wettkampf',
  company: 'Unternehmen',
  phoneTagline: 'Sport-Tipps mit Freunden.',
  copyright: '© 2026 Zporti. Von Fußballfans, für Fußballfans.',
  copyrightShort: '© 2026 Zporti',
} as const

export const organizationsDe = {
  heroBadge: 'Für Teams, Ligen & Marken',
  heroTitle: 'Organisationen auf Zporti',
  heroLead:
    'Führe deine Gruppe mit eigener Identität in Zporti. Lege Markenfarben und Logos fest, lade Mitglieder mit einem Beitrittscode ein und verwalte Plätze an einem Ort — damit alle ein stimmiges Erlebnis sehen, wenn sie gemeinsam spielen und tippen.',
  valueSectionTitle: 'Was du bekommst',
  valueBrandingTitle: 'Marke, die sich nach dir anfühlt',
  valueBrandingBody:
    'Lade deine Logos hoch, wähle Primär- und Sekundärfarben und sieh dir an, wie sie in der App erscheinen. Admins halten das Erscheinungsbild konsistent — ohne Code.',
  valueMembersTitle: 'Mitglieder & Plätze',
  valueMembersBody:
    'Erstelle eine Organisation oder tritt mit einem Code bei. Sieh, wer dabei ist, verwalte Kapazität mit Platzlimits deines Plans und kopiere einen Beitrittscode beim Onboarding neuer Leute.',
  valueMascotTitle: 'Marken-Maskottchen & Avatare',
  valueMascotBody:
    'Optionale markenspezifische Maskottchen-Stimmungen und org-exklusive Avatar-Sets lassen deine Community auffallen — ideal für Fan-Gruppen, Firmen-Ligen und Partner.',
  howSectionTitle: 'So funktioniert es',
  howStep1: 'Melde dich an, erstelle dann eine Organisation oder tritt mit einem Einladungscode deines Admins bei.',
  howStep2: 'Admins öffnen Organisationseinstellungen, um Branding, Mitglieder und Kontodetails anzupassen.',
  howStep3: 'Mitglieder nutzen die App wie gewohnt — mit den Visuals und Vorteilen deiner Organisation, wo aktiviert.',
  signIn: 'Anmelden',
  signUp: 'Konto erstellen',
  heroPanelTitle: 'Organisations-Kontrollzentrum',
  heroPanelBody:
    'Mitglieder einladen, Branding festlegen und jeder Gruppe vor dem Anpfiff ein stimmiges Zuhause geben.',
} as const

export const b2bContactDe = {
  title: 'Lieber, dass wir es für dich einrichten?',
  subtitle: 'Fülle deine Angaben aus und unser Team meldet sich.',
  orgNameLabel: 'Organisationsname *',
  orgNamePlaceholder: 'Deine Organisation',
  contactNameLabel: 'Dein Name *',
  contactNamePlaceholder: 'Vollständiger Name',
  emailLabel: 'E-Mail *',
  emailPlaceholder: 'you@example.com',
  messageLabel: 'Nachricht',
  messagePlaceholder: 'Erzähl uns von deinen Anforderungen (optional)',
  submitButton: 'Anfrage senden',
  scheduleMemo: 'Oder Termin vereinbaren — demnächst',
  errorFallbackValidation: 'Bitte überprüfe deine Eingaben und versuche es erneut.',
  errorFallbackSubmit: 'Senden fehlgeschlagen. Bitte versuche es erneut.',
  successMessage: 'Danke! Wir haben deine Anfrage erhalten und melden uns in Kürze.',
} as const

export const signInDe = {
  signUpSubtitle: 'Registriere dich, um loszulegen',
  signInSubtitle: 'Melde dich an, um fortzufahren',
  emailPlaceholder: 'E-Mail',
  passwordPlaceholder: 'Passwort',
  forgotPassword: 'Passwort vergessen?',
  signUpButton: 'Registrieren',
  signInButton: 'Anmelden',
  alreadyHaveAccount: 'Bereits ein Konto? ',
  noAccount: 'Noch kein Konto? ',
  toggleSignIn: 'Anmelden',
  toggleSignUp: 'Registrieren',
  orDivider: 'ODER',
  signInWith: 'Anmelden mit',
  continueAsGuest: 'oder als Gast fortfahren',
  legalConsentPrefix: 'Ich habe die ',
  legalConsentAnd: ' und ',
  legalConsentSuffix: ' gelesen und stimme zu.',
  marketingConsent: 'Ich stimme zu, Produktupdates und Marketing-E-Mails von Zporti zu erhalten.',
  loading: 'Wird geladen…',
  sendingResetEmail: 'Reset-E-Mail wird gesendet',
  signingUp: 'Registrierung läuft',
  signingIn: 'Anmeldung läuft',
  continuingWithGoogle: 'Weiter mit Google',
  continuingWithFacebook: 'Weiter mit Facebook',
  enteringAsGuest: 'Als Gast eintreten',
} as const

export const a11yDe = {
  openMenu: 'Menü öffnen',
  closeMenu: 'Menü schließen',
  heroMascot: 'Zporti-Maskottchen mit Smartphone',
} as const

export const accountAdminSiteDe = {
  backToSite: '← Zurück zur Website',
} as const
